import type { CartPromoState } from '~/stores/cartPromo'
import type { CoreFetch } from '~/types/CoreFetch'

export function provideGetWalletReferralPromo(coreFetch: CoreFetch) {
  return function () {
    return coreFetch.$get<CartPromoState>(`/wallet/referral-promo/`)
  }
}
